import { Component } from '@angular/core';

@Component({
  selector: 'app-review-form-header',
  templateUrl: './review-form-header.component.html',
  styleUrl: './review-form-header.component.scss',
  standalone: false,
})
export class ReviewFormHeaderComponent {}
